import { api } from "./client";
import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // adjust if needed

export const fetchOutOfStockProducts = async () => {
  try {
    const lang = localStorage.getItem("language") || "en";

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": lang,
      },
    };

    const response = await api.get(`${API_BASE_URL}api/out-of-stock/list`, config);
    console.log("✅ Out of stock product list response:", response.data);

    // Adjust return based on backend response format
    return response.data; // or response.data.data if your backend nests data
  } catch (error) {
    console.error("❌ Error fetching out-of-stock products:", error);
    toast.error(`${window.translate("Failed to fetch out-of-stock products")}`);
    return [];
  }
};
